import templateUrl from './product.view.html'

/**
 * Product view route
 *
 * @namespace routes.ReportProductView
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.products.view',
  label: 'REPORT.PRODUCTS.VIEW.TITLE',
  component: 'tmrReportProductView',
  resolve: {
    productImageEnabled: /*@ngInject*/ appConfiguration =>
      appConfiguration['product.image.enabled'],
  },
  accessControl: ['Resource.view', 'Resource.Product.view'],
  abstract: false,
}

/**
 * Component for {@link routes.tmrReportProductView Product view route}
 *
 * @type {ngComponent}
 */
export const tmrReportProductView = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrReportProductViewController',
  bindings: {
    resource: '<',
    productImageEnabled: '<',
  },
}

/**
 * Controller of component {@link tmrReportProductView}.
 *
 * @type {ngController}
 */
export class tmrReportProductViewController {
  static ngType = 'controller'

  $onInit() {
    this.attributesCount = Object.values(this.resource.attributes).length
  }
}
